
// Define types for article data
export interface ArticleData {
  id: number;
  slug: string;
  title: string;
  description: string;
  author: string;
  publishDate: string;
  lastUpdated?: string; // Added lastUpdated as an optional property
  category: string;
  readTime: string;
  readCount: number;
  likeCount: number;
  contentPath?: string;
  externalUrl?: string;
  previousArticleSlug?: string;
  isPremium?: boolean;
  comingSoon?: boolean;
  content?: string;
  tags?: string[];
  featured?: boolean;
  imageUrl?: string;
  contentType?: string;
  excerpt?: string; // Made excerpt optional to match existing usage
  forcePreview?: boolean; // Added forcePreview property
  isPreviewEnabled?: boolean; // Added isPreviewEnabled property
  images?: { [key: string]: string }; // Added images property as an optional object mapping string keys to string values
}

// Define article categories as constants
export const CATEGORY = {
  ML_FUNDAMENTALS: "ML Fundamentals",
  SYSTEM_DESIGN: "System Design Case Studies",
} as const;
